// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3wATu","head":"Table_head__342h6","col":"Table_col__37X6j"};